import React, { useEffect } from 'react'
import { DataPicIndividu } from '../../components'
import { useLocation } from 'react-router-dom';

const ProfilCorporatePage = () => {
    
    const location = useLocation();

    useEffect(() => {
        window.dataLayer.push({
            event: 'pageview',
            page: {
            url: window.location.pathname + window.location.search,
            title: document.title
            }
        });
    }, [location]);

    return (
        <div>
            <h3>Profil Individu</h3>
            <nav aria-label="breadcrumb" >
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <span href="#" style={{
                            color: '#B5B5C3'
                        }}>Beranda</span>
                    </li>
                    <li className="breadcrumb-item active" ariaCurrent="page" style={{
                        color: '#3F4254'
                    }}>Data Profil</li>
                </ol>
            </nav>
            <div className='row mt-4 mb-4'>
                <div className='col-lg-12'>
                    <DataPicIndividu />
                </div>
            </div>
        </div>
    )
}

export default ProfilCorporatePage
